
<script>
// Extensions
import View from '@/views/View';

// Mixins
import LoadSections from '@/mixins/load-sections';

export default {
  name: 'Home',

  metaInfo: { title: 'Home' },

  extends: View,

  mixins: [
    LoadSections([
      'hero',
      'what-we-do',
      'we-work-on',
      'contact-us',
      'info',

      // 'theme-features',
      // 'features',

      // 'affiliates',
      // 'social-media',
      // 'keep-in-touch',
      // 'newsletter',
      // 'pro-features',
    ]),
  ],

  props: {
    id: {
      type: String,
      default: 'home',
    },
  },
};
</script>
